<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Tarefa"
    }
  },
  data: () => ({
    projetoList: undefined,
    tarefaStatusList: {},
    //tarefaPrioridadeList: {},
    clienteList: {},
    expedienteTipoList: {},
    expedienteLocalList: {},
    tarefaPrecedenciaList: {},
    consultorList: {},
    clienteId: undefined,
    projetoId: undefined,
    ready: false,
    item: { percentualConclusao: 0 },
    contratoList: {},
    clienteContratoList: {},
    contratoAtivoList: {},
    contratoId: null,
    alertShow:false,
    alertMsg:'',
    EmEdicao: false
  }),
  created() {
    if (this.$route.query.projetoId) {      
      this.projetoId = this.$route.query.projetoId;      
    }
    if (this.$route.query.clienteId) {
      this.clienteId = this.$route.query.clienteId;
    }

    this.ready = true;
    
    this.getTarefaStatusList();
    this.getClienteList();

    
    
    if (this.clienteId) {
      this.getProjetoList();
      this.getClienteContratoList();
    }

    this.getExpedienteLocalList();
    this.getExpedienteTipoList();
    this.getTarefaPrecedenciaList();

    if (this.projetoId) {
      this.getConsultorListProjeto();
    }else {
      this.getConsultorList();
    }
  },    
  methods: {
    get(id) {
      api.get(`api/${this.table}/${id}`).then(response => {
        
        this.item = response.data["data"];        
        this.EmEdicao = true;
        this.clienteId = this.item.clienteId;        
        this.projetoId = this.item.projetoId;        
        this.contratoId = this.item.contratoId;

        if (this.copy === true) {
          
          this.item.id = null;
          this.editForm = true;
        }
        this.getTarefaPrecedenciaList();
        
      });
    },
    remove() {
      this.showModalDelete = true;
    },
    cancelRemove() {
      this.showModalDelete = false;
    },
    confirmRemove() {
      if (this.item.id) {
        api.delete(`api/Tarefa/${this.item.id}`).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.back();
          }
        });
        this.selectedId = null;
        this.showModalDelete = false;
      }
    },
    getClienteList() {
      api
        .get(`crud/Expediente/Clientes`)
        .then(response => (this.clienteList = response.data["data"]));
    },
    getProjetoList() {
      if (this.clienteId) {
        api
          .get(`crud/projeto/listaProjetos`, {
            params: {
              clienteId: this.clienteId              
            }
          })
          .then(response => {
            this.projetoList = response.data["data"];
          });
      }
    },
    getTarefaStatusList() {
      api
        .get(`crud/TarefaStatus`)
        .then(response => (this.tarefaStatusList = response.data["data"]));
    },
    getExpedienteTipoList() {
      api
        .get(`crud/Expediente/ExpedienteTipos`)
        .then(response => (this.expedienteTipoList = response.data["data"]));
    },
    getExpedienteLocalList() {
      api
        .get(`crud/Expediente/ExpedienteLocal`)
        .then(response => (this.expedienteLocalList = response.data["data"]));
    },
    getTarefaPrecedenciaList() {
      api
        .get(`api/Tarefa/Tarefas`, {
          params: {            
            clienteId: this.clienteId,
            ativo: true
          }
        })
        .then(response => {
          this.tarefaPrecedenciaList = response.data["data"];
        });
    },
    getConsultorListProjeto() {
      api
        .get(`api/Tarefa/ConsultoresProjeto`,{params: {projetoId: this.projetoId}})
        .then(response => {
          this.consultorList = response.data["data"];
        });
    },
    save() {
      if(this.contratoId != null || this.projetoId != undefined){
        // update
        if (this.item.id) {
          api.put(`api/${this.table}`, this.item).then(response => {
            if (response.data["status"].toLowerCase() == "success") {
              this.hasSuccess = true;
              this.back();
            }
          });
        }
        // insert
        else {
          api.post(`api/${this.table}`, this.item).then(response => {
            if (response.data["status"].toLowerCase() == "success") {
              this.hasSuccess = true;
              this.back();
            }
          });
        }
      }else{
        this.alertMsg = 'Selecione um Projeto, um Contrato ou ambos';
        this.alertShow = true;
      }
      
    },
    getContratoList() {
      api
        .get(`crud/Contrato`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC",
            ativo: true
          }
        })
        .then(response => (this.contratoList = response.data["data"]));
    },
    getClienteContratoList() {       
      api.get(`crud/Contrato/listaContratos`,{
        params: {
          clienteId: this.clienteId           
        }
        
      }).then(response => {
        this.clienteContratoList = response.data["data"];
        if(this.EmEdicao == true){
          this.contratoAtivoList = this.clienteContratoList;
        }else{
          this.contratoAtivoList = this.clienteContratoList.filter(cont => cont.ativo == true);
        }
        this.contratoList = this.contratoAtivoList.filter(cont => cont.clienteId == this.clienteId)
      });      
        
    },
    contratosAtivosPorCliente(){
      if(this.contratoAtivoList){
        this.contratoList = this.contratoAtivoList.filter(cont => cont.clienteId == this.clienteId)
      }
      
    },
    closeAlert(){
      this.alertShow = false;
    },
    getConsultorList() {
      api
        .get(`Crud/Consultor/Consultores`)
        .then(response => {
          this.consultorList = response.data["data"];
        });
    },
    start(){      
      if (this.$route.query.projetoId) {
        this.projetoId = this.$route.query.projetoId;
      }
    },
    limparForms(){      
      this.projetoId = undefined;
      this.contratoId = undefined;
      this.tarefaPrecedenciaList = {};
    }
  },
  watch: {
    clienteId: function() {
      this.item.clienteId = this.clienteId;
      if (this.ready === true) {
        this.getProjetoList();
        this.getTarefaPrecedenciaList();        
      }
      this.getClienteContratoList();
    },
    projetoId: function() {      
      if (this.projetoList !== undefined ) {        
        let projeto = this.projetoList.filter(
          a => a.id == this.projetoId
        )[0];
        if (projeto) {
          this.item.projetoId = projeto.id;
          this.item.expedienteTipoId = projeto.expedienteTipoId;
          this.item.expedienteLocalId = projeto.expedienteLocalId;          
          this.getConsultorListProjeto();
        }else if( this.contratoId ){
          this.getConsultorList();
        }else{          
          this.getConsultorList();
        }
      }
    },    
    contratoId: function(){
      this.item.contratoId = this.contratoId
      if(!this.projetoId){
        this.getConsultorList();
      }
      
    }
  }
};
</script>

<template>
  <div>
    <b-alert
      variant="danger"
      dismissible
      :show="this.alertShow"
      @dismissed="closeAlert"
    >
      {{ this.alertMsg }}
    </b-alert>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Cliente"
          label-for="clienteId"
        >
          <b-form-select
            id="clienteId"
            v-model="clienteId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in clienteList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Projeto"
          label-for="projetoId"
        >
          <b-form-select
            id="projetoId"
            v-model="projetoId"
            :disabled="!this.editForm"            
          >
            <b-form-select-option :value="undefined"
              >(Sem Projeto)</b-form-select-option
            >
            <b-form-select-option
              v-for="option in projetoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Contrato"
          label-for="contratoId"
        >
          <b-form-select
            id="contratoId"
            v-model="contratoId"
            :disabled="!this.editForm"            
          >
            <b-form-select-option  :value="(undefined || null)" 
              >(Sem contrato)</b-form-select-option
            >
            <b-form-select-option
              v-for="option in contratoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao}}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Denominação"
          label-for="denominacao"
          class="col-md-6"
        >
          <b-form-input
            id="denominacao"
            v-model="item.denominacao"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="col-md-6"
          id="input-group-1"
          label="Possui tarefa precedente?"
          label-for="tarefaPrecedente"
        >
          <b-form-select
            id="tarefaPrecedente"
            v-model="item.precedenteId"
            :disabled="!this.editForm"
          >
            <b-form-select-option :value="null">Não</b-form-select-option>
            <b-form-select-option
              v-for="option in tarefaPrecedenciaList"
              :key="option.tarefaId"
              :value="option.tarefaId"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-6"
          id="input-group-1"
          label="Responsável"
          label-for="responsavel"
        >
          <b-form-select
            id="responsavel"
            v-model="item.responsavelId"
            required
            :disabled="!this.editForm"
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in consultorList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Tipo Expediente Padrão"
          label-for="expedienteTipoId"
        >
          <b-form-select
            id="expedienteTipoId"
            v-model="item.expedienteTipoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteTipoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Local Expediente Padrão"
          label-for="expedienteLocalId"
        >
          <b-form-select
            id="expedienteLocalId"
            v-model="item.expedienteLocalId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteLocalList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.denominacao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Ch Previsto"
          label-for="ChPrevisto"
          class="col-md-2"
        >
          <b-form-input
            id="ChPrevisto"
            v-model="item.chPrevisto"
            type="number"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" class="text-center mt-4 col-md-3">
          <b-form-checkbox
            v-model="item.visivelParaCliente"
            :disabled="!this.editForm"
            name="check-button"
            switch
          >
            Visível para o cliente <i>(em breve)</i>
          </b-form-checkbox>
        </b-form-group>
      </div>

      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-textarea
          id="descricao"
          v-model="item.descricao"
          type="text"
          :disabled="!this.editForm"
          rows="5"
        />
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button variant="danger" v-if="item.id != null" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
       
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
